import { Component, OnInit } from '@angular/core';
import { CommissionService } from 'src/app/service/commission.service';
import { LoggerService } from 'src/app/service/logger.service';
import { ManageUserService } from 'src/app/service/manage-user.service';
import { AuthGaurdService } from 'src/app/service/auth-gaurd.service';
import { NotificationService } from 'src/app/service/notification.service';
import { NotificationType } from '../../enum/notification-type.enum';
import { HttpErrorResponse } from '@angular/common/http';
import { AddUser } from 'src/app/models/manageUsers/add-user.model';
import { MatTableDataSource } from '@angular/material/table';
import { AdjustmentsModel } from 'src/app/commission/adjustments/adjustments.model';
import { AdjustmentSearchModel } from 'src/app/commission/adjustments/adjustmentSearch.model';
import { FormControl, NgForm } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';
import { ErrorResponseMessage } from 'src/app/error-handler/error-response-message.model';
import { RateCodes } from 'src/app/models/commission/rate-codes.model';
import { CalendarService } from 'src/app/service/calendar.service';
import { CalendarModel } from 'src/app/models/config/calendar.model';
import { map, startWith } from 'rxjs/operators';
import { MyDocsModel } from '../../models/upload/mydocs.model';
import { ManageCodesService } from 'src/app/service/managecodes.service';

@Component({
  selector: 'app-adjustments',
  templateUrl: './adjustments.component.html',
  styleUrls: ['./adjustments.component.css']
})
export class AdjustmentsComponent implements OnInit {

  public adjustmentsModel = new AdjustmentsModel(0, null, 0, 0, 0, '', '', '', '', 0,null,'','','','','','',false);
  public adjustmentSearch = new AdjustmentSearchModel(0, null, 0);
  userData: AddUser[] = [];
  adjustmentsData: AdjustmentsModel[] = [];
  sectedUserdata = new AddUser();
  salesChannels: Array<AddUser> = [];
  comPlansUserData: Array<AddUser> = [];
  filteredUserData: AddUser[] = [];
  isShowCodes: boolean = false;
  userModel = new AddUser();
  private subscriptions: Subscription[] = [];
  productsData: RateCodes[] = [];
  public showLoading: boolean;
  calendarTypes: CalendarModel[];
  calendarData: CalendarModel[];
  filteredCalderData: Observable<CalendarModel[]> | undefined;
  calendarCtrl = new FormControl();
  editMode: boolean = false;

  constructor(private manageCodesService: ManageCodesService,private commissionService: CommissionService,
    private logger: LoggerService, private manageUserService: ManageUserService,
    private authGurdService: AuthGaurdService,private notificationService : NotificationService,
    private calendarService: CalendarService) { }
    public dataSource = new MatTableDataSource<AddUser>();

  ngOnInit(): void {

    this.init();
    this.editMode = false;
  }

  public init() {

    this.getSalesChannel();
    this.getCommissionStr();
    this.getCommPeriodUnlockValu();
  }

  getSalesChannel() {
    this.manageUserService.getPrePopulatedUserData().subscribe((data: any) => {
      this.logger.info(data);
      this.userData = data;
      for (let userInfo of this.userData) {
        if (userInfo.sales_rep_channel != null && userInfo.sales_rep_channel != 'NA')
          this.salesChannels.push(userInfo);         
         // if(this.salesChannels.length>1){
        //    this.salesChannels.sort((a, b) =>
        //       a.localeCompare(b));
        //    }
      }

    }, (errorResponse: HttpErrorResponse) => {
      var msg: any;
      msg = errorResponse;
      this.notificationService.sendNotification(NotificationType.ERROR, msg);
    })
  }

  getCommissionStr() {
    this.manageUserService.getPrePopulatedUserData().subscribe((data: any) => {
      this.logger.info(data);
      this.userData = data;
      for (let userInfo of this.userData) {
        if (userInfo.commission_plan != null && userInfo.commission_plan != 'NA')
          this.comPlansUserData.push(userInfo);
         // if(this.comPlansUserData.length>1){
         //   this.comPlansUserData.sort((a, b) =>
         //      a.localeCompare(b));
         //   }
      }

    }, (errorResponse: HttpErrorResponse) => {
      var msg: any;
      msg = errorResponse;
      this.notificationService.sendNotification(NotificationType.ERROR, msg);
    })
  }

  getAllProducts() {
    this.manageCodesService.getCodeTypes()
      .subscribe((data: any) => {
        this.logger.info(data);
        this.productsData = data;
        console.log(this.productsData);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  private _normalizeValue(value: string): string {
    if(value){
      console.log(value.toLowerCase().replace(/\s/g, ''));
    return value.toLowerCase().replace(/\s/g, '');
    }
    else
    return '';
  }

  userSearch() {
   
   
     if(this.adjustmentSearch.commissionPeriod != 0 || this.adjustmentSearch.sales_rep_channel != null || this.adjustmentSearch.commission_plan !=0){     
      this.isShowCodes = true;
      console.log("Inside userSearch():",this.adjustmentSearch);
      this.commissionService.getAdjust(this.adjustmentSearch.commissionPeriod,this.adjustmentSearch.sales_rep_channel,this.adjustmentSearch.commission_plan)
        .subscribe((data: AdjustmentsModel[]) => {
          this.adjustmentsData = data;
          console.log("userSearch() = "+JSON.stringify(this.adjustmentsData));
         
        }, (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        });   
    }else{
      this.notificationService.sendNotification(NotificationType.ERROR, "Please enter one or more search criteria");
    }
  }

  private findData() {
    if (this.filteredUserData.length > 0) {
      this.userData = this.filteredUserData;
    }
  }
  private clickButton(buttonId: string): void {
    document.getElementById(buttonId).click();
  }
  
  public openAdjstmentPopup(secectAdjMentRow:AddUser): void {
    //this.getCommissionStr();
    this.adjustmentsModel.fixedDollarAmt=secectAdjMentRow.commission_plan;
    this.getAllProducts();
    this.sectedUserdata=secectAdjMentRow;
    this.clickButton('openAdjstmentPopup');
  }

  saveAdjustment(adjustMentsForm:NgForm){
      adjustMentsForm.reset();
      
   }

  

  public getCommPeriodUnlockValu() {
    this.calendarService.getCommPeriodUnlockValues("CORPORATE_MONTHLY")
      .subscribe((data: CalendarModel[]) => {
        this.calendarData = data;
        this.filterCalData();
        console.log(this.calendarData);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  filterCalData() {
    this.filteredCalderData = this.calendarCtrl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value))
    );
  }

  private _filter(value: string): CalendarModel[] {
    const filterValue = this._normalizeValue(value);
    return this.calendarData.filter(item => this._normalizeValue(item.commPeriod).includes(filterValue));
  }

  

  public editTableRow(userdoc: AdjustmentsModel, values: any){
    
    userdoc.editMode = false;
    
    userdoc.editMode = true;

  }
  public close(userdoc: AdjustmentsModel,value:any)
   {
    
    userdoc.editMode = false;
   }

   //public saveEditValue(userdoc: AdjustmentsModel){ 
  //   alert(userdoc.fixedDollarAmt);
  //   alert(userdoc.newTier);
  //   alert(userdoc.comments);
  //  userdoc.editMode = false;
  //  this.insertAdjustments();
    //this.notificationService.sendNotification(NotificationType.SUCCESS, `Adjustments added successfully`);
 //  }

   public saveEditValue(userdoc: AdjustmentsModel){    
    userdoc.editMode = false;
    this.showLoading = true;
    console.log(' the new userModel is ', this.adjustmentsModel)
    this.adjustmentsModel=userdoc;
    this.commissionService.addAdjust(this.adjustmentsModel)
      .subscribe(response => {      
        this.notificationService.sendNotification(NotificationType.SUCCESS, `Adjustments added successfully`);
        this.showLoading = false;       
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
        this.showLoading = false;
      }
      )
  }

}
